import React from 'react'
import Breadcrumbs from '../Breadcrumbs'

export const flatten = children => {
  const result = []

  React.Children.forEach(children, child => {
    if (React.isValidElement(child) && child.type === React.Fragment) {
      result.push(...flatten(child.props.children))
    } else if (child !== null) {
      result.push(child)
    }
  })

  return result
}

export default ({id, title, subtitle, breadcrumbs, className, buttons, children}) => {
  const flattenedButtons = flatten(buttons)
  const renderTitle = React.isValidElement(title) ? title : <h1 className='title is-4'>{title}</h1>
  const renderSubtitle = React.isValidElement(subtitle) ? subtitle : <h2 className='is-size-5'>{subtitle}</h2>

  return (
    <section id={id} className={`section ${className}`}>
      <div className='container'>
        <nav className='level'>
          <div className='level-left'>
            <div className='level-item'>
              <div>
                <Breadcrumbs breadcrumbs={breadcrumbs}>{title && renderTitle}</Breadcrumbs>
                {subtitle && renderSubtitle}
              </div>
            </div>
          </div>
          <div className='level-right'>
            {buttons ? (
              <div className='level-item'>
                <div className='field is-grouped'>
                  {React.Children.map(flattenedButtons, (child, i) => (
                    <div className='control' key={i}>
                      {child}
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </div>
        </nav>
        {children}
      </div>
    </section>
  )
}
